<script>
	import { CONTACT_VARS } from '$lib/consts'
	import { CONTACT } from '$lib/routes'
	import { t } from '$lib/translations'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'
</script>

<section
	class="flex h-fit w-full max-w-lg flex-col gap-7 overflow-hidden rounded-2xl bg-white p-10-res-75 pb-8-res-75"
>
	<h2 class="unstyled mb-3 text-1.5xl font-extrabold md:text-1.5xl lg:text-1.5xl">
		{t('web.about_us.contact.heading')}
	</h2>
	{#if CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].phoneRef && CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].phoneNum}
		<div class="flex items-center gap-4">
			<img src="/images/icons/phone-green.svg" alt="phone" class="mx-1 aspect-square h-6" />
			<div class="phone">
				<a
					href={CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].phoneRef}
					class="text-4.5xl-res font-semibold text-green-700 sm:text-1.5xl lg:text-3xl"
					>{CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].phoneNum}</a
				>
				<div class="text-neutral-400">({t('web.about_us.contact.phoneAvailability')})</div>
			</div>
		</div>
	{/if}
	{#if CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].mail}
		<div class="flex items-center gap-4">
			<img src="/images/icons/email-red.svg" alt="email" class="aspect-square h-8" />
			<div class="mail">
				<a
					href="mailto:{CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].mail}"
					class="text-4.5xl-res font-semibold text-primary-500 sm:text-1.5xl lg:text-3xl"
					>{CONTACT_VARS[PUBLIC_WOLTAIR_WEB_CODE].mail}</a
				>
				<div class="text-neutral-400">({t('web.about_us.contact.mailAvailability')})</div>
			</div>
		</div>
	{/if}
	<a
		href="/{CONTACT}"
		class="link transition-color mt-5 flex items-center justify-between border-t-[1px] border-neutral-200 pt-5 font-semibold hover:text-primary-500"
		><span class="text-xs">{t('web.about_us.contact.allContacts')}</span>
		<img
			src="/images/icons/arrow/next-red.svg"
			alt="Arrow"
			class="ml-2 h-[1em] transition-transform"
		/></a
	>
</section>

<style lang="scss">
	.link:hover {
		img {
			transform: translateX(4px);
		}
	}
</style>
